import { render, staticRenderFns } from "./channelItem.vue?vue&type=template&id=7bb9c942&scoped=true&"
import script from "./channelItem.vue?vue&type=script&lang=js&"
export * from "./channelItem.vue?vue&type=script&lang=js&"
import style0 from "./channelItem.vue?vue&type=style&index=0&id=7bb9c942&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb9c942",
  null
  
)

export default component.exports